var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc046af9424efaed9d4f599d27e9b1cc63c984c8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hyapp@coins-ag"]={id:"bc046af9424efaed9d4f599d27e9b1cc63c984c8"};
      